import {
    getFilterRepo, getListRepo, putDetailRepo, getDetailRepo, PostDetailRepo
} from "../repositories/domainMapping";
import { createSlice } from "@reduxjs/toolkit";

const domainMappingSlice = createSlice({
    name: "domainMappingReducer",
    initialState: {
        keywordFilterLoading: false,
        keywordFilterData: null,
        keywordFilterError: null,

        domainFilterLoading: false,
        domainFilterData: null,
        domainFilterError: null,

        degreeFilterLoading: false,
        degreeFilterData: null,
        degreeFilterError: null,

        levelFilterLoading: false,
        levelFilterData: null,
        levelFilterError: null,

        verticalFilterLoading: false,
        verticalFilterData: null,
        verticalFilterError: null,

        listLoading: false,
        listData: null,
        listError: null,

        putDetailLoading: false,
        putDetailData: null,
        putDetailError: null,

        getDetailLoading: false,
        getDetailData: null,
        getDetailError: null,

        postDetailLoading: false,
        postDetailData: null,
        postDetailError: null,

        message:null,
    },
    reducers: {

        getKeywordFilterLoading(state, action) {
            return {
                ...state,
                keywordFilterLoading: true,
            };
        },
        getKeywordFilterSuccess(state, action) {
            return {
                ...state,
                keywordFilterLoading: false,
                keywordFilterData: action.payload,
            };
        },
        getKeywordFilterFailure(state, action) {
            return {
                ...state,
                keywordFilterLoading: false,
                keywordFilterError: action.payload,
            };
        },

        getDomainFilterLoading(state, action) {
            return {
                ...state,
                domainFilterLoading: true,
            };
        },
        getDomainFilterSuccess(state, action) {
            return {
                ...state,
                domainFilterLoading: false,
                domainFilterData: action.payload,
            };
        },
        getDomainFilterFailure(state, action) {
            return {
                ...state,
                domainFilterLoading: false,
                domainFilterError: action.payload,
            };
        },

        getDegreeFilterLoading(state, action) {
            return {
                ...state,
                degreeFilterLoading: true,
            };
        },
        getDegreeFilterSuccess(state, action) {
            return {
                ...state,
                degreeFilterLoading: false,
                degreeFilterData: action.payload,
            };
        },
        getDegreeFilterFailure(state, action) {
            return {
                ...state,
                degreeFilterLoading: false,
                degreeFilterError: action.payload,
            };
        },

        getLevelFilterLoading(state, action) {
            return {
                ...state,
                levelFilterLoading: true,
            };
        },
        getLevelFilterSuccess(state, action) {
            return {
                ...state,
                levelFilterLoading: false,
                levelFilterData: action.payload,
            };
        },
        getLevelFilterFailure(state, action) {
            return {
                ...state,
                levelFilterLoading: false,
                levelFilterError: action.payload,
            };
        },

        getVerticalFilterLoading(state, action) {
            return {
                ...state,
                verticalFilterLoading: true,
            };
        },
        getVerticalFilterSuccess(state, action) {
            return {
                ...state,
                verticalFilterLoading: false,
                verticalFilterData: action.payload,
            };
        },
        getVerticalFilterFailure(state, action) {
            return {
                ...state,
                verticalFilterLoading: false,
                verticalFilterError: action.payload,
            };
        },

        getListLoading(state, action) {
            return {
                ...state,
                listLoading: true,
            };
        },
        getListSuccess(state, action) {
            return {
                ...state,
                listLoading: false,
                listData: action.payload,
            };
        },
        getListFailure(state, action) {
            return {
                ...state,
                listLoading: false,
                listError: action.payload,
            };
        },

        putDetailsLoading(state, action) {
            return {
                ...state,
                putDetailLoading: true,
            };
        },
        putDetailSuccess(state, action) {
            return {
                ...state,
                putDetailLoading: false,
                putDetailData: action.payload,
                message: "WA URL Mapping Updated Successfully"
            };
        },
        putDetailFailure(state, action) {
            return {
                ...state,
                putDetailLoading: false,
                putDetailError: action.payload,
                message:action.payload,
            };
        },

        getDetailsLoading(state, action) {
            return {
                ...state,
                getDetailLoading: true,
            };
        },
        getDetailSuccess(state, action) {
            return {
                ...state,
                getDetailLoading: false,
                getDetailData: action.payload,
            };
        },
        getDetailFailure(state, action) {
            return {
                ...state,
                getDetailLoading: false,
                getDetailError: action.payload,
                message:action.payload,
            };
        },

        postDetailsLoading(state, action) {
            return {
                ...state,
                postDetailLoading: true,
            };
        },
        postDetailSuccess(state, action) {
            return {
                ...state,
                postDetailLoading: false,
                postDetailData: action.payload,
                message: "WA URL Mapping Added Successfully"
            };
        },
        postDetailFailure(state, action) {
            return {
                ...state,
                postDetailLoading: false,
                postDetailError: action.payload,
                message:action.payload,
            };
        },

        clearMessage(state, action) {
            return {
                ...state,
                message:null,
                postDetailError:null,
                putDetailError:null,
            };
        },

        clearData(state, action) {
            return {
                ...state,
                degreeFilterData:null,
                getDetailData:null,
                postDetailData:null,
                putDetailData:null,
            };
        },

    },
});
export const {

    getKeywordFilterLoading,
    getKeywordFilterSuccess,
    getKeywordFilterFailure,
    
    getDomainFilterLoading,
    getDomainFilterSuccess,
    getDomainFilterFailure,

    getDegreeFilterLoading,
    getDegreeFilterSuccess,
    getDegreeFilterFailure,

    getLevelFilterLoading,
    getLevelFilterSuccess,
    getLevelFilterFailure,

    getVerticalFilterLoading,
    getVerticalFilterSuccess,
    getVerticalFilterFailure,

    getListLoading,
    getListSuccess,
    getListFailure,

    putDetailsLoading,
    putDetailSuccess,
    putDetailFailure,

    getDetailsLoading,
    getDetailSuccess,
    getDetailFailure,

    postDetailsLoading,
    postDetailSuccess,
    postDetailFailure,

    clearMessage,
    clearData,

} = domainMappingSlice.actions;

export const getKeywordFilter = (params) => {
    return async (dispatch) => {
        dispatch(getKeywordFilterLoading());
        await getFilterRepo(params)
            .then((response) => {
                if (response?.status >= 200 || response?.status <= 300){
                    dispatch(getKeywordFilterSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getKeywordFilterFailure(error.message));
                }
            });
    };
};


export const getDomainFilter = (params) => {
    return async (dispatch) => {
        dispatch(getDomainFilterLoading());
        await getFilterRepo(params)
            .then((response) => {
                if (response?.status >= 200 || response?.status <= 300){
                    dispatch(getDomainFilterSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getDomainFilterFailure(error.message));
                }
            });
    };
};

export const getDegreeFilter = (params) => {
    return async (dispatch) => {
        dispatch(getDegreeFilterLoading());
        await getFilterRepo(params)
            .then((response) => {
                if (response?.status >= 200 || response?.status <= 300){
                    dispatch(getDegreeFilterSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getDegreeFilterFailure(error.message));
                }
            });
    };
};

export const getLevelFilter = (params) => {
    return async (dispatch) => {
        dispatch(getLevelFilterLoading());
        await getFilterRepo(params)
            .then((response) => {
                if (response?.status >= 200 || response?.status <= 300){
                    dispatch(getLevelFilterSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getLevelFilterFailure(error.message));
                }
            });
    };
};

export const getVerticalFilter = (params) => {
    return async (dispatch) => {
        dispatch(getVerticalFilterLoading());
        await getFilterRepo(params)
            .then((response) => {
                if (response?.status >= 200 || response?.status <= 300){
                    dispatch(getVerticalFilterSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getVerticalFilterFailure(error.message));
                }
            });
    };
};

export const getList = (params) => {
    return async (dispatch) => {
        dispatch(getListLoading());
        await getListRepo(params)
            .then((response) => {
                if (response?.status >= 200 || response?.status <= 300){
                    dispatch(getListSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getListFailure(error.message));
                }
            });
    };
};

export const putMappingDetail = (params, id) => {
    return async (dispatch) => {
      dispatch(putDetailsLoading());
      await putDetailRepo(params, id)
        .then((response) => {
          if (response?.status >= 200 && response?.status < 300) {
            dispatch(putDetailSuccess(response?.data?.data));
          }
        })
        .catch((error) => {
          if (error && error.response) {
            dispatch(putDetailFailure(error.response?.data?.message));
          }
        });
    };
  };

export const getMappingDetail = (id) => {
    return async (dispatch) => {
        dispatch(getDetailsLoading());
        await getDetailRepo(id)
            .then((response) => {
                if (response?.status >= 200 || response?.status <= 300){
                    dispatch(getDetailSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getDetailFailure(error.message));
                }
            });
    };
};

export const postMappingDetail = (id) => {
    return async (dispatch) => {
        dispatch(postDetailsLoading());
        await PostDetailRepo(id)
            .then((response) => {
                if (response?.status >= 200 || response?.status <= 300){
                    dispatch(postDetailSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(postDetailFailure(error.response?.data?.message));
                }
            });
    };
};

export default domainMappingSlice.reducer;